module.exports = __webpack_public_path__ + "static/img/culture.8a6eabc7.png";